import { gql } from 'apollo-boost';

const manyQuery = gql`
  query athletes($inputFilter: UserFilterInputObjectType) {
    athletes(inputFilter: $inputFilter) {
      id
      clubId
      firstName
      lastName
      middleName
      enFullName
      fullName
      gender
      status
      athleteStatus
      types
      email
      permissions
      rank
      birthday
      trainerIds
      phone
      address
      qualification
      sections {
        id
        name
      }
      club {
        id
        shortName
      }
      photo {
        id
        url
      }
      contributions {
        id
        addedAt
        year
        amount
        type
        createdAt
        updatedAt
        userId
        trainerId
      }
      trainers {
        id
        fullName
        fullInitials
      }
      gyms {
        id
        name
      }
      mainTrainerId
    }
  }
`;

const athletesForGroupQuery = gql`
  query athletesForGroup($inputFilter: UserFilterInputObjectType) {
    athletesForGroup(inputFilter: $inputFilter) {
      id
      clubId
      firstName
      lastName
      middleName
      enFullName
      fullName
      gender
      status
      athleteStatus
      types
      email
      permissions
      rank
      birthday
      trainerIds
      phone
      address
      qualification
      sections {
        id
        name
      }
      club {
        id
        shortName
      }
      photo {
        id
        url
      }
      contributions {
        id
        addedAt
        year
        amount
        type
        createdAt
        updatedAt
        userId
        trainerId
      }
      trainers {
        id
        fullName
      }
    }
  }
`;

const oneQuery = gql`
  query athlete($id: Int!) {
    athlete(id: $id) {
      id
      clubId
      firstName
      lastName
      middleName
      enFullName
      fullName
      email
      gender
      status
      athleteStatus
      types
      permissions
      rank
      birthday
      trainerIds
      phone
      address
      qualification
      leagueId
      sections {
        id
        name
      }
      mainTrainerId
      documentIds {
        id
        url
        originalName
      }
      club {
        id
        shortName
      }
      photo {
        id
        url
      }
    }
  }
`;

export const createMutation = gql`
  mutation createAthlete($inputData: AthleteInputType!) {
    createAthlete(inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const updateMutation = gql`
  mutation updateAthlete($id: Int!, $inputData: AthleteInputType!) {
    updateAthlete(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const deleteMutation = gql`
  mutation deleteAthlete($id: Int!) {
    deleteAthlete(id: $id) {
      ok
      errors {
        field
        messages
      }
    }
  }
`;

export const blockMutation = gql`
  mutation blockAthlete($id: Int!, $reason: String!, $blockExpireAt: String!) {
    blockAthlete(id: $id, reason: $reason, blockExpireAt: $blockExpireAt) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

export const archivateMutation = gql`
  mutation archivateAthlete($id: Int!, $reason: String!) {
    archivateAthlete(id: $id, reason: $reason) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

export const activateMutation = gql`
  mutation activateAthlete($id: Int!) {
    activateAthlete(id: $id) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

export const changeGroupMutation = gql`
  mutation changeAthleteGroupMutation(
    $athleteId: Int!
    $fromGroupId: Int!
    $toGroupId: Int!
  ) {
    updateAthleteGroup(
      id: $athleteId
      fromGroupId: $fromGroupId
      toGroupId: $toGroupId
    ) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

export const addAthleteToGroupMutation = gql`
  mutation addAthleteToGroupMutation($athleteId: Int!, $toGroupId: Int!) {
    addAthleteToGroup(id: $athleteId, toGroupId: $toGroupId) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

export const setUserTypesMutation = gql`
  mutation setUserTypes($id: Int!, $inputData: SetUserTypesInputType!) {
    setUserTypes(id: $id, inputData: $inputData) {
      ok
      errors {
        field
        messages
        code
      }
    }
  }
`;

export const generateProfileInfoMutation = gql`
  mutation generateProfileInfo($id: Int!) {
    generateProfileInfo(id: $id) {
      ok
      url
      errors {
        field
        messages
      }
    }
  }
`;

const paginatedAthletesQuery = gql`
  query paginatedAthletes($inputFilter: UserFilterInputObjectType) {
    paginatedAthletes(inputFilter: $inputFilter) {
      items {
        id
        clubId
        firstName
        lastName
        middleName
        enFullName
        fullName
        gender
        status
        athleteStatus
        types
        email
        permissions
        rank
        birthday
        trainerIds
        phone
        address
        qualification
        sections {
          id
          name
        }
        club {
          id
          shortName
        }
        photo {
          id
          url
        }
        contributions {
          id
          addedAt
          year
          amount
          type
          createdAt
          updatedAt
          userId
          trainerId
        }
        mainTrainerId
        trainers {
          id
          fullName
          fullInitials
        }
        gyms {
          id
          name
        }
      }
      pageInfo {
        page
        pages
        total
      }
    }
  }
`;

export const generateAthletesXlsMutation = gql`
  mutation generateAthletesXls($inputData: GenerateAthleteXlsInputType!) {
    generateAthletesXls(inputData: $inputData) {
      ok
      url
      errors {
        code
        field
        messages
      }
    }
  }
`;

const generateAthletesXlsStatusQuery = gql`
  query generateAthletesXlsStatus($requestId: String!) {
    generateAthletesXlsStatus(requestId: $requestId) {
      progress
      url
    }
  }
`;

const ATHLETES = {
  manyQuery,
  oneQuery,
  createMutation,
  updateMutation,
  deleteMutation,
  blockMutation,
  archivateMutation,
  activateMutation,
  changeGroupMutation,
  setUserTypesMutation,
  generateProfileInfoMutation,
  athletesForGroup: athletesForGroupQuery,
  paginatedAthletesQuery,
  addAthleteToGroupMutation,
  generateAthletesXlsMutation,
  generateAthletesXlsStatusQuery,
};

export default ATHLETES;
